/**
 * Resolves the effective sync group for a time series chart based on an optional prop override
 * and the app metadata context.
 */
export function resolveSyncGroup(
  syncGroupProp: string | false | undefined,
  appMetadataApp: string | undefined
): string | undefined {
  if (syncGroupProp === false) return undefined;
  return syncGroupProp ?? appMetadataApp ?? 'default-group';
}
